import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { isAuthenticated as isAuthenticatedService } from '../features/auth/services/index.service'

import { getRequiredPermissionsForPath } from '@/features/rbac/pathPermissions'
import { SUPER_ADMIN_WILDCARD } from '@/features/rbac/types'
import {
  selectIsSuperAdmin,
  selectPermissions,
} from '@/store/slices/authSlice'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation()
  const hasToken = isAuthenticatedService()
  const isSuperAdmin = useSelector(selectIsSuperAdmin)
  const permissions = useSelector(selectPermissions)

  if (!hasToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!isSuperAdmin && !permissions.includes(SUPER_ADMIN_WILDCARD)) {
    const required = getRequiredPermissionsForPath(location.pathname)
    if (required && !required.some((code) => permissions.includes(code))) {
      return (
        <Navigate
          to="/403"
          replace
          state={{ from: location.pathname, anyOf: required }}
        />
      )
    }
  }

  return <>{children}</>
}

export default ProtectedRoute
